export default {
  namespaced: true,
  state: {
    playTimes: 0
  },
  mutations: {
    ADD_PLAY_TIMES (state) {
      state.playTimes = state.playTimes + 1
    },
    RESET_PLAY_TIMES (state) {
      state.playTimes = 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/video.js